module.exports = __webpack_public_path__ + "static/media/logo3.2b48a476.png";